import { useEffect } from 'react'
import { useTracking } from 'react-tracking'

import { PageEventGroup } from '../groups/pages'

import { Page } from './enum'

export function usePageTracking(page: Page) {
	const tracking = useTracking({ page })

	useEffect(() => {
		tracking.trackEvent(PageEventGroup.events.open())
	}, [tracking])

	return tracking
}
